// /static/public/bundles/articles.bundle.js
import './index.scss';
import Dropdown from 'bootstrap/js/dist/dropdown';
import * as jQuery from 'jquery';
import {config} from 'core/config';
import {flipbox} from 'modules/flipbox';
import {imagePopup} from 'modules/imagePopup/new.js';
import {tableWrapper} from 'modules/tableWrapper';
import {aside} from 'modules/aside';
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import 'swiper/scss/navigation';

window.$ = jQuery;

$(function() {

    flipbox.bindEvents();
    imagePopup.init();
    aside.init();

    if (document.querySelector('.article_content-wrap') !== null) {
        tableWrapper.init('.article_content-wrap');
    }

    const swiperElements = document.querySelectorAll('.SwiperGoods');
    swiperElements.forEach(element => {
        new Swiper(element, {
            slidesPerView: 5,
            spaceBetween: 7,
            modules: [Navigation],
            navigation: {
                nextEl: element.closest('.sliderGoods').querySelector('.sliderGoods-next'),
                prevEl: element.closest('.sliderGoods').querySelector('.sliderGoods-prev'),
            },
            breakpoints: {
                0: { slidesPerView: 1, spaceBetween: 0 },
                375: { slidesPerView: 1.5, spaceBetween: 14 },
                550: { slidesPerView: 2, spaceBetween: 7 },
                1010: { slidesPerView: 3, spaceBetween: 7 },
                1310: { slidesPerView: 4, spaceBetween: 7 },
                1450: { slidesPerView: 5, spaceBetween: 7 },
            },
        });
    });



});